export default function (value: string | null | Date) {
    return new Date(value || "now").toLocaleString(undefined, {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
    });
}
